<template>
	<div
		class="g-block-body-gray-tip g-block-body-padding"
		:class="{
			'g-block-body-gray-tip--edit': editable,
			'is-active': editable && active,
			'g-block-body-gray-tip--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-gray-tip__shell">
			<div class="g-block-body-gray-tip__title-wrap">
				<div class="g-block-body-gray-tip__title-mask">
					<RichTextEditable
						v-if="editable"
						class="g-block-body-gray-tip__title"
						fit-content
						:style="{ color: themeColor }"
						:model-value="data.title"
						placeholder="请输入标题"
						@update:model-value="onTitleUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-body-gray-tip__title"
						:style="{ color: themeColor }"
						v-html="data.title || ''"
					></div>
				</div>
			</div>
			<div class="g-block-body-gray-tip__frame">
				<RichTextEditable
					v-if="editable"
					class="g-block-body-gray-tip__text"
					:model-value="data.content"
					placeholder="请输入正文"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-gray-tip__text"
					v-html="data.content || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	export default {
		name: 'GBlockBodyGrayTip',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	@title-overlap: 12px;

	.g-block-body-gray-tip {
		.body-block-edit-shell();
	}

	.g-block-body-gray-tip__shell {
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}

	.g-block-body-gray-tip__title-wrap {
		position: relative;
		z-index: 1;
		display: flex;
		justify-content: center;
		margin-bottom: -@title-overlap;
	}

	.g-block-body-gray-tip__title-mask {
		display: inline-flex;
		max-width: calc(100% - 24px);
		padding: 0 10px;
		background: #fff;
		line-height: 0;
	}

	.g-block-body-gray-tip__title {
		.body-title-base();
		font-size: 16px;
		font-weight: 700;
		text-align: center;
		white-space: nowrap;

		:deep(.g-rich-text-editable__content) {
			text-align: center;
			white-space: nowrap;
		}
	}

	.g-block-body-gray-tip__frame {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		padding: calc(@title-overlap + 8px) 14px 14px;
		background: #fff;
		box-sizing: border-box;
	}

	.g-block-body-gray-tip__text {
		.body-text-base();
		color: #666;
	}

	.g-block-body-gray-tip--h5 {
		@title-overlap-h5: 0.24rem;

		.g-block-body-gray-tip__title-wrap {
			margin-bottom: calc(-1 * @title-overlap-h5);
		}
		.g-block-body-gray-tip__title-mask {
			max-width: calc(100% - 0.48rem);
			padding: 0 0.2rem;
		}
		.g-block-body-gray-tip__title {
			font-size: 0.32rem;
		}
		.g-block-body-gray-tip__frame {
			border-radius: 0.08rem;
			padding: calc(@title-overlap-h5 + 0.16rem) 0.28rem 0.28rem;
		}
		.body-text-base--h5(~'.g-block-body-gray-tip__text');
	}
</style>
